import { type Image } from '@capsicum/common';

export const MARKETING_BANNER_SLIDE_INTERVAL = 5000;

// This must be aligned with the BO specifications 9:16 ratio
export const DRAWER_IMAGE_MIN_HEIGHT = 544;
export const DRAWER_IMAGE_MIN_WIDTH = 306;

export enum MarketingBannerThemes {
	CHILIZ = 'Chiliz',
	CHILIZ_INVERSE = 'Chiliz Inverse',
	CUSTOM = 'Custom',
	PEPPER = 'Pepper',
	SOCIOS = 'Socios',
	SOCIOS_LIGHT = 'Socios Light'
}

export enum MarketingBannerImageTypes {
	SOCIAL_MARKETING_BANNER_BACKGROUND = 'social:marketing_banner:background',
	SOCIAL_MARKETING_BANNER_DRAWER_BACKGROUND = 'social:marketing_banner:drawer_background',
	SOCIAL_MARKETING_BANNER_IMAGE = 'banner'
}

type MarketingBannerActionTrigger = () => void;

export type MarketingBannerModalAction = {
	label?: string;
	onTrigger?: MarketingBannerActionTrigger;
	url?: string;
};

type MarketingBannerAction =
	| {
			backgroundColor?: string;
			body?: string;
			image?: null | Pick<Image, 'blurHash' | 'url'>;
			onTrigger?: MarketingBannerActionTrigger;
			primary: MarketingBannerModalAction;
			secondary?: MarketingBannerModalAction;
			type: 'modal';
	  }
	| {
			onTrigger?: MarketingBannerActionTrigger;
			type: 'link';
			url: string;
	  };

export type MarketingBannerDetails = {
	action?: MarketingBannerAction;
	body?: string;
	cta?: string;
	header?: string;
	id: string;
	image: null | Pick<Image, 'blurHash' | 'url'>;
	subtitle?: string;
	theme?: MarketingBannerThemes;
};

export type MarketingBannerModalProps = Pick<MarketingBannerDetails, 'header' | 'image' | 'subtitle'> & {
	backgroundImage?: null | Pick<Image, 'blurHash' | 'url'>;
	body?: string;
	primaryAction?: () => void;
	theme: MarketingBannerThemes;
};

export type MarketingBannerModalFooterProps = {
	onClose?: () => void;
	primary: MarketingBannerModalAction;
	secondary?: MarketingBannerModalAction;
	theme: MarketingBannerThemes;
};
